var _excluded = ["shouldWrap", "maxHeight", "style", "children"],
  _excluded2 = ["className"],
  _excluded3 = ["className", "isSelected"],
  _excluded4 = ["className"],
  _excluded5 = ["className", "expandable", "isRowSelected", "onRowClick", "headers", "maxHeight", "items", "disableSortReset", "onSort", "onScrollToEnd", "sort", "selectedItems", "truncateHeaders"];
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef, useMemo, useRef, useCallback, useState } from "react";
import { keyCodes } from "../../utils/helpers";
import AInView from "../AInView";
import AIcon from "../AIcon";
import ASimpleTable from "../ASimpleTable";
import { ASkeleton, ASkeletonText } from "../ASkeleton";
import "./ADataTable.scss";

/**
 * Used inside ADataTable to enable proper styling
 * for infinite scrolling
 */
var ADataTableWrapper = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var shouldWrap = _ref.shouldWrap,
    maxHeight = _ref.maxHeight,
    style = _ref.style,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (!shouldWrap) {
    return children;
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    "data-testid": "table-wrapper",
    style: _objectSpread(_objectSpread({}, style), {}, {
      overflowY: "scroll",
      maxHeight: maxHeight
    })
  }, rest), children);
});
ADataTableWrapper.displayName = "ADataTableWrapper";
var TableHeader = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement("th", _extends({
    ref: ref,
    role: "columnheader",
    className: "a-data-table__header".concat(className ? " ".concat(className) : "")
  }, rest));
});
TableHeader.displayName = "TableHeader";
var TableRow = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var propsClassName = _ref3.className,
    isSelected = _ref3.isSelected,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  var className = "a-data-table__row";
  if (isSelected) {
    className += " a-data-table__row--selected";
  }
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  return /*#__PURE__*/React.createElement("tr", _extends({
    ref: ref,
    role: "row",
    className: className
  }, rest));
});
TableRow.displayName = "TableRow";
var TableCell = /*#__PURE__*/React.forwardRef(function (_ref4, ref) {
  var className = _ref4.className,
    rest = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement("td", _extends({
    ref: ref,
    role: "cell",
    className: "a-data-table__cell".concat(className ? " ".concat(className) : "")
  }, rest));
});
TableCell.displayName = "TableCell";
export var getSortIconName = function getSortIconName(column, sort) {
  if (!sort || column.key !== sort.key) {
    return "sort-empty";
  }
  switch (sort.direction) {
    case "asc":
      return "sort-up";
    case "desc":
      return "sort-down";
    default:
      return "sort-empty";
  }
};
var ADataTable = /*#__PURE__*/forwardRef(function (_ref5, ref) {
  var propsClassName = _ref5.className,
    expandable = _ref5.expandable,
    propsIsRowSelected = _ref5.isRowSelected,
    propsOnRowClick = _ref5.onRowClick,
    headers = _ref5.headers,
    maxHeight = _ref5.maxHeight,
    items = _ref5.items,
    _ref5$disableSortRese = _ref5.disableSortReset,
    disableSortReset = _ref5$disableSortRese === void 0 ? false : _ref5$disableSortRese,
    onSort = _ref5.onSort,
    onScrollToEnd = _ref5.onScrollToEnd,
    sort = _ref5.sort,
    selectedItems = _ref5.selectedItems,
    truncateHeaders = _ref5.truncateHeaders,
    rest = _objectWithoutProperties(_ref5, _excluded5);
  var tableWrapperRef = useRef();
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    expandedRows = _useState2[0],
    setExpandedRows = _useState2[1];
  var ExpandableComponent = useMemo(function () {
    return expandable === null || expandable === void 0 ? void 0 : expandable.component;
  }, [expandable]);
  var className = "a-data-table";
  if (ExpandableComponent) {
    className += " a-data-table--expandable";
  }
  if (truncateHeaders) {
    className += " a-data-table--truncate-headers";
  }
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  var toggleRow = useCallback(function (id) {
    return function () {
      setExpandedRows(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, id, !prev[id]));
      });
    };
  }, [setExpandedRows]);
  var sortedItems = useMemo(function () {
    return _toConsumableArray(items);
  }, [items], sort);
  if (sort) {
    var sortDir = sort.direction === "desc" ? -1 : 1;
    var targetHeader = Object.values(headers).find(function (x) {
      return x.key === sort.key;
    });
    var sortFunc = function sortFunc(a, b) {
      return a === b ? 0 : a < b ? -1 : 1;
    };
    if (targetHeader && typeof targetHeader.sort === "function") {
      sortFunc = targetHeader.sort;
    }
    if (!targetHeader || targetHeader.sort !== false) {
      sortedItems.sort(function (a, b) {
        return sortDir * sortFunc(a[sort.key], b[sort.key]);
      });
    }
  }
  return headers && items && /*#__PURE__*/React.createElement(ADataTableWrapper, {
    ref: tableWrapperRef,
    shouldWrap: typeof onScrollToEnd === "function" || maxHeight,
    maxHeight: maxHeight
  }, /*#__PURE__*/React.createElement(ASimpleTable, _extends({}, rest, {
    ref: ref,
    className: className
  }), headers && /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement(TableRow, {
    onClick: function onClick(e) {
      return typeof propsOnRowClick === "function" && propsOnRowClick(headers, e);
    }
  }, ExpandableComponent && /*#__PURE__*/React.createElement(TableHeader, {
    className: "a-data-table__header a-data-table__header--hidden"
  }, /*#__PURE__*/React.createElement("span", {
    className: "a-data-table__header--hidden__text"
  }, "Toggle")), headers.map(function (x, i) {
    var headerProps = {
      className: "a-data-table__header ".concat(x.sortable ? "a-data-table__header--sortable" : "", " text-").concat(x.align || "start", " ").concat(x.className || "").replace("  ", " ").trim(),
      role: "columnheader",
      scope: "col",
      "aria-label": x.name,
      style: x.style,
      wrap: x.wrap
    };
    var sortableBtnProps = {};
    var onClick;
    if (x.sortable) {
      if (!sort || x.key !== sort.key) {
        headerProps["aria-label"] += ": Not sorted. Activate to sort ascending.";
        headerProps["aria-sort"] = "none";
      } else if (sort && sort.direction === "asc") {
        headerProps["aria-label"] += ": Sorted ascending. Activate to sort descending.";
        headerProps["aria-sort"] = "ascending";
      } else {
        headerProps["aria-label"] += ": Sorted descending. Activate to remove sorting.";
        headerProps["aria-sort"] = "descending";
      }
      onClick = function onClick() {
        setExpandedRows({});
        if (!onSort) {
          return;
        }
        if (!disableSortReset) {
          onSort(sort && sort.key === x.key && sort.direction === "desc" ? null : {
            key: x.key,
            direction: sort && x.key === sort.key && sort.direction === "asc" ? "desc" : "asc"
          });
        } else {
          onSort({
            key: x.key,
            direction: sort && x.key === sort.key && sort.direction === "asc" ? "desc" : "asc"
          });
        }
      };
    }
    if (!x.sortable) {
      return /*#__PURE__*/React.createElement(TableHeader, _extends({}, headerProps, {
        key: "a-data-table_header_".concat(i)
      }), /*#__PURE__*/React.createElement("span", {
        className: "a-data-table__header__label"
      }, x.name));
    }
    var sortIcon = x.sortable && /*#__PURE__*/React.createElement(AIcon, {
      left: x.align === "end",
      right: x.align !== "end",
      className: "a-data-table__header__sort ".concat(sort && x.key === sort.key ? "a-data-table__header__sort--active" : "")
    }, getSortIconName(x, sort));
    return /*#__PURE__*/React.createElement(TableHeader, _extends({}, headerProps, {
      key: "a-data-table_header_".concat(i),
      tabIndex: 0,
      onClick: onClick,
      onKeyDown: function onKeyDown(e) {
        if ([keyCodes.enter, keyCodes.space].includes(e.keyCode)) {
          e.preventDefault();
          onClick && onClick(e);
        }
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "a-data-table__header__sort-wrap"
    }, x.align == "end" && sortIcon, /*#__PURE__*/React.createElement("button", _extends({}, sortableBtnProps, {
      tabIndex: -1,
      className: "a-data-table__header__sort__button"
    }), /*#__PURE__*/React.createElement("span", {
      className: "a-data-table__header__label"
    }, x.name)), x.align !== "end" && sortIcon));
  }), ExpandableComponent && /*#__PURE__*/React.createElement(TableHeader, null, "Additional Details"))), /*#__PURE__*/React.createElement("tbody", null, sortedItems.map(function (rowItem, i) {
    var key = "a-data-table_row_".concat(i);
    var id = "a-data-table_row_".concat(i);
    var isLastRow = i == items.length - 1;
    var isInfiniteScrollTarget = isLastRow && typeof onScrollToEnd === "function";
    var hasExpandedRowContent = ExpandableComponent && (typeof expandable.isRowExpandable === "function" ? expandable.isRowExpandable(rowItem) : true);
    var isRowSelected = typeof propsIsRowSelected === "function" && propsIsRowSelected(rowItem);
    var rowContent = /*#__PURE__*/React.createElement(TableRow, {
      "data-expandable-row": hasExpandedRowContent,
      isSelected: isRowSelected,
      key: key,
      onClick: function onClick(e) {
        return typeof propsOnRowClick === "function" && propsOnRowClick(rowItem, e);
      }
    }, ExpandableComponent && /*#__PURE__*/React.createElement(TableCell, null, hasExpandedRowContent && /*#__PURE__*/React.createElement("button", {
      "aria-expanded": expandedRows[id] ? true : false,
      "aria-controls": id,
      className: "a-data-table__cell__btn--expand",
      onClick: toggleRow(id)
    }, /*#__PURE__*/React.createElement(AIcon, {
      size: 12
    }, expandedRows[id] ? "chevron-down" : "chevron-right"))), headers.map(function (y, j) {
      var _y$cell;
      var cellLoading = rowItem.cellLoading;
      var content = cellLoading ? /*#__PURE__*/React.createElement(ASkeleton, {
        hidePanelBackdrop: true,
        animated: true,
        style: {
          padding: 0
        }
      }, /*#__PURE__*/React.createElement(ASkeletonText, null)) : y.cell && y.cell.component ? y.cell.component(rowItem) : rowItem[y.key];
      return /*#__PURE__*/React.createElement(TableCell, {
        key: "a-data-table_cell_".concat(j),
        className: "text-".concat(y.align || "start", " ").concat(((_y$cell = y.cell) === null || _y$cell === void 0 ? void 0 : _y$cell.className) || "").trim()
      }, content);
    }), hasExpandedRowContent && /*#__PURE__*/React.createElement(TableCell, {
      id: id,
      "data-expandable-content": true,
      hidden: !expandedRows[id],
      role: "cell"
    }, /*#__PURE__*/React.createElement(ExpandableComponent, rowItem)));
    if (!isInfiniteScrollTarget) {
      return rowContent;
    }
    return /*#__PURE__*/React.createElement(AInView, {
      key: key,
      triggerOnce: true,
      onChange: function onChange(_ref6) {
        var inView = _ref6.inView,
          entry = _ref6.entry;
        if (inView) {
          onScrollToEnd(entry);
        }
      }
    }, rowContent);
  }))));
});
ADataTable.propTypes = {
  /**
   * Toggles the `altLinks` display variant. If the table has many links, use this to display them in the base text color.
   */
  altLinks: PropTypes.bool,
  /**
   * Configuration object for expandable table rows
   */
  expandable: PropTypes.shape({
    /** The component to be rendered on expansion */
    component: PropTypes.func.isRequired,
    /**
     * (optional): A function called when rendering each row to determine
     * if the row can be expanded an collapsed
     */
    isRowExpandable: PropTypes.func
  }),
  /**
   * Sets the table headers.
   */
  headers: PropTypes.arrayOf(PropTypes.shape({
    /** The text to be displayed in the header column */
    name: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    /** The unique identifier to associate a column with subsequent row data */
    key: PropTypes.string,
    /** CSS class used to style the header column */
    className: PropTypes.string,
    /** The alignment of the header column text content */
    align: PropTypes.oneOf(["start", "center", "end"]),
    /** Determines if the column can be sorted by the user */
    sortable: PropTypes.bool,
    /** Sorting function for the column data */
    sort: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    /** Object that refers to the column's associated data table cells, i.e., <td /> elements */
    cell: PropTypes.shape({
      /** Class to be added to each table data element */
      className: PropTypes.string,
      /** Custom component to be rendered for each table data item */
      component: PropTypes.func
    })
  })).isRequired,
  /**
   * A function called when rendering each row to determine if
   * the row is selected. It is passed the associated row item.
   */
  isRowSelected: PropTypes.func,
  /**
   * Sets the table data.
   */
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * A function called when the table row (<tr>) is clicked. It is passed
   * the associated row item as the first argument, and the native event
   * object as the second.
   */
  onRowClick: PropTypes.func,
  /**
   * Called when the user reaches the bottom of the data table for the first time.
   */
  onScrollToEnd: PropTypes.func,
  /**
   * Handles the `sort` event.
   */
  onSort: PropTypes.func,
  /**
   * Sets the sort.
   */
  sort: PropTypes.shape({
    key: PropTypes.string,
    direction: PropTypes.oneOf(["asc", "desc"])
  }),
  /**
   * Disables third click of header sort icon to unset sorting.
   */
  disableSortReset: PropTypes.bool,
  /**
   * Toggles the `striped` display variant. Darkened backgrounds for alternate rows.
   */
  striped: PropTypes.bool,
  /**
   * Toggles the `tight` display variant. Smaller row heights.
   */
  tight: PropTypes.bool,
  /**
   * Automatically truncate header text with ellipses when applicable
   */
  truncateHeaders: PropTypes.bool
};
ADataTable.displayName = "ADataTable";
export default ADataTable;